import { Link } from 'react-router-dom';

export default function BrandMark({ compact = false }) {
  return (
    <Link className={`brand-mark ${compact ? 'brand-mark--compact' : ''}`} to="/" aria-label="Jonny's Towing home">
      <span className="brand-mark__hook" aria-hidden="true">J</span>
      <span className="brand-mark__copy">
        <strong>JONNY'S</strong>
        <span>TOWING &amp; RECOVERY</span>
      </span>
    </Link>
  );
}
